/**
 * Waits for a given amount of time before resolving.
 */
export const wait = (ms = 3000) => new Promise((res) => setTimeout(res, ms));
/**
 * Queues a task to be executed on the next tick of the event loop.
 * Prevents the current call stack from growing and the script from blocking.
 */
export const queueMacrotask = wait.bind(null, 0);
